import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { workflowError } from "@/lib/workflow-api";

export function WorkflowFeedback({ error, retry }: { error: unknown; retry?: () => void }) {
  return <div role="alert" className="flex flex-wrap items-center gap-3 rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-900">
    <AlertCircle aria-hidden="true" className="h-5 w-5 shrink-0" />
    <p className="min-w-0 flex-1">{workflowError(error)}</p>
    {retry && <Button type="button" variant="outline" size="sm" onClick={retry}><RefreshCw aria-hidden="true" className="mr-2 h-4 w-4" />Tentar novamente</Button>}
  </div>;
}
